
export default {
  components: {},
  props: {
    order: {
      required: true,
      type: Object,
      default: null,
    },
    description: {
      required: false,
      default: "",
      type: String,
    },
    layout: {
      required: false,
      default: "chain",
      type: String,
    },
  },
  data: () => ({
    test: null,
  }),
  computed: {
    icon() {
      if (!this.order.isProduct) {
        switch (true) {
          case ((this.order.status === "future-visit" && !this.order.isProductReservation) || this.isFutureButNotYetPaid) && !this.isCancelled:
            return "fxt-calendar";
          case this.order.status === "previous-visit":
            return "fxt-calendar-check";
          case (this.order.status === "cancelled" && !(this.order.fairPayStatus === 'PAID' && this.order.status === 'cancelled')) || this.isCancelled:
            return "fxt-cancel";
          case this.order.status === "product-purchase" || this.order.isProductReservation:
            return "fxt-dispenser";
          case this.order.status === "noshow" || (this.order.fairPayStatus === 'PAID' && this.order.status === 'cancelled'):
            return "fxt-calendar-off";
        }
      } else {
        return this.order.status === "Cancelled" ? "fxt-cancel" : "fxt-dispenser";
      }
    },
    iconColor() {
      return this.isCancelled || this.isCancelledNoShow ? 'error' : (this.order.status === "future-visit" && !this.order.isProductReservation) || ['noshow', 'cancelled'].includes(this.order.status) && this.order.fairPayStatus === 'NEW' && this.layout == 'portal' ? '#579fa7' : 'primary'
    },
    isFutureButNotYetPaid() { //For x timer siden
      return (['future-visit', 'noshow'].includes(this.order.status) && this.order.fairPayStatus === 'NEW')
    },
    isNormalNoshow() { //Ikke møtt til besøk
      return (this.order.status === 'noshow' && (!this.order.fairPayStatus || this.order.fairPayStatus === 'UNKNOWN'))
    },
    isPaidCancelFee() { //Ikke møtt til besøk
      return this.order.fairPayStatus === 'PAID' && ['cancelled'].includes(this.order.status);
    },
    isPaidNoShowFee() { //Ikke møtt gebyr
      return this.order.fairPayStatus === 'PAID' && ['noshow'].includes(this.order.status);
    },
    isPardoned() {
      return this.order.fairPayStatus === 'PARDONED'
    },
    isCancelled() { //Linethrough and red color
      return (['cancelled','Cancelled'].includes(this.order.status) && (!this.order.fairPayStatus || this.order.fairPayStatus === 'UNKNOWN')) || this.isPaidCancelFee || this.isNormalNoshow || this.isLateCancellation
    },
    isCancelledNoShow() { //Linethrough and red color
      return (['cancelled','Cancelled'].includes(this.order.status) && this.order.fairPayStatus === 'PARDONED')
    },
    isLateCancellation() {
      return this.order.fairPayStatus === 'NEW'  && ['cancelled'].includes(this.order.status)
    }
  },
  methods: {
    getDate(appointmentDate) {
      return new Date(appointmentDate).toLocaleDateString("no-NO", {
        year: "numeric",
        month: this.$vuetify.breakpoint.smAndDown ? "numeric" : "long",
        day: "numeric",
      });
    },
    formatPrice(price) {
      if (this.order.isProduct && this.order.status === "Credited") {
        return "-" + price.toFixed(2).replace(".", ",");
      }
      return price.toFixed(2).replace(".", ",");
    },
  },
};
